import { FieldValues } from "react-hook-form";
import {
  AppContextType,
  ListViewsContextType,
} from "../../context/ApplicationContext";
import { evaluateExpression } from "../../functions/parser";
import { FieldConfiguration, SectionConfiguration } from "./form-configuration";

export const validateRequiredFields = (
  currentSection: SectionConfiguration,
  fieldValues: FieldValues,
  applicationContext: AppContextType,
  listContext: ListViewsContextType
): boolean => {
  let ret: boolean = true;
  if (currentSection.type == "f") {
    let fields: Array<FieldConfiguration> = currentSection.fields ?? [];
    ret = setFieldState(fields, fieldValues, applicationContext);
    applicationContext.sectionState.errorState[currentSection.id] = ret;
  } else {
    ret = validateListViewRequiredRows(currentSection.id, listContext);
  }

  return ret;
};

export const validateListViewRequiredRows = (
  sectionId: string,
  listContext: ListViewsContextType
): boolean => {
  const minimumNumRows: number = listContext[sectionId].minimumNumberOfRows;
  const numberOfRows: number = listContext[sectionId].dataModel.uiModel.length;
  const isListValid: boolean = numberOfRows >= minimumNumRows;
  listContext[sectionId].errorState.state = isListValid;
  listContext[sectionId].errorState.message =
    "The list must have at least " +
    listContext[sectionId].minimumNumberOfRows +
    " record(s).";
  return isListValid;
};

export const validateInputForm = (
  currentSection: SectionConfiguration,
  fieldValues: FieldValues,
  applicationContext: AppContextType
): boolean => {
  let ret: boolean = false;

  let sections: Array<SectionConfiguration> = currentSection.forms![0].sections;
  let fields: Array<FieldConfiguration> = [];
  sections.forEach((section: SectionConfiguration) => {
    let theseFields = section.fields ?? [];
    fields.push(...theseFields);
  });

  ret = setFieldState(fields, fieldValues, applicationContext);

  return ret;
};

export const setFieldState = (
  fields: FieldConfiguration[],
  fieldValues: FieldValues,
  applicationContext: AppContextType
): boolean => {
  let ret: boolean = true;

  fields.forEach((field: FieldConfiguration) => {
    //console.log(field);

    let requiredTokens: string[] = [];

    if (field.extendedAttributes)
      if (field.extendedAttributes["required"])
        requiredTokens = field.extendedAttributes["required"].split(" ");

    const value = fieldValues[field.id];
    const isFieldRequired: boolean = evaluateExpression(
      requiredTokens,
      fieldValues
    );
    const isCurrentFieldValid: boolean =
      applicationContext.fieldState[field.id];
    // console.log(field.label + "[" + value + "]");
    // console.log(isCurrentFieldValid);
    // console.log(!isFieldRequired && isCurrentFieldValid);
    // console.log(isFieldRequired && isCurrentFieldValid);
    // console.log(
    //   !(
    //     value === undefined ||
    //     value === null ||
    //     (typeof value === "object" && value.id === "") ||
    //     value === ""
    //   )
    // );
//    console.log(field.id);
//    console.log(value);
    let isFieldValid: boolean =
      (!isFieldRequired && isCurrentFieldValid) ||
      (isFieldRequired &&
        isCurrentFieldValid &&
        !(
         (Array.isArray(value) && value.length == 0) ||
          value === undefined ||
          value === null ||
          (typeof value === "object" && value.id === "") ||
          value === "" 
        ));

    ret = ret && isFieldValid;
    applicationContext.fieldState[field.id] = isFieldValid;
  });

  return ret;
};
